"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var __1 = require("..");
var enums_1 = require("../../Common/utils/enums");
var VerifyAccountController_1 = __importDefault(require("../VerifyAccountController"));
var PhoneEmailVerifyLayout_1 = __importDefault(require("./PhoneEmailVerifyLayout"));
var UpdateNumber_1 = __importDefault(require("./UpdateNumber"));
var PhoneEmailVerification = function (_a) {
    var channel = _a.channel, override = _a.override, requiresPageLayout = _a.requiresPageLayout, disableDismiss = _a.disableDismiss;
    var _b = __read(React.useState(enums_1.MfaStates.Loading), 2), mfaState = _b[0], setMfaState = _b[1];
    return (React.createElement(PhoneEmailVerifyLayout_1["default"], { disableDismiss: disableDismiss, mfaState: mfaState, requiresPageLayout: requiresPageLayout },
        React.createElement(__1.VerifyAccountProvider, { blockChannelSwitch: true, channel: channel, mfaState: mfaState, override: override, setMfaState: setMfaState },
            React.createElement(VerifyAccountController_1["default"], { additionalMfaOptions: React.createElement(UpdateNumber_1["default"], null), initialChannel: channel }))));
};
exports["default"] = PhoneEmailVerification;
